import { Routes, Route } from "react-router-dom";
import QyR from "../pages/QyR";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Gastos from "../pages/Gastos";
import Perfil from "../pages/Perfil";
import Usuarios from "../pages/Usuarios";
import Dashboard from "../pages/Dashboard";
import NotFound from "../pages/404/NotFound";
import Estadisticas from "../pages/Estadisticas";
import Layout from "../components/layouts/Layout";
import Inmobiliarias from "../pages/Inmobiliarias";
import Inmueble from "../pages/inmuebles/Inmueble";
import Inmuebles from "../pages/inmuebles/Inmuebles";
import InmuebleDoc from "../pages/inmuebles/InmuebleDoc";
import UsuariosCrud from "../pages/usuarios/UsuariosCrud";
import InmuebleEdoCuenta from "../pages/inmuebles/InmuebleEdoCuenta";
import InmuebleFacturas from "../pages/inmuebles/InmuebleFacturas";
import InmuebleQYR from "../pages/inmuebles/InmuebleQYR";
import Mantenimiento from "../pages/Mantenimiento";
import InmuebleUser from "../pages/usuario/InmuebleUser";
import InmuebleRenta from "../pages/inmuebles/InmuebleRenta";
import PrivacyPolicy from "../pages/Privacy";
import SupportPage from "../pages/Support";

function AppRouter() {
	return (
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/privacy" element={<PrivacyPolicy />} />
			<Route path="/support" element={<SupportPage />} />
			<Route path="/login" element={<Login />} />
			<Route path="/inicio" element={<Layout> <Dashboard /> </Layout>} />
			<Route path="/perfil" element={<Layout> <Perfil /> </Layout>} />
			<Route path="/usuarios" element={<Layout> <Usuarios /> </Layout>} />
			<Route path="/usuarios/:type" element={<Layout> <UsuariosCrud /> </Layout>} />
			<Route path="/inmobiliarias" element={<Layout> <Inmobiliarias /> </Layout>} />
			<Route path="/inmobiliarias/:id" element={<Layout> <Inmuebles /> </Layout>} />
			<Route path="/inmobiliarias/:id/:im" element={<Layout> <Inmueble /> </Layout>} />
			<Route path="/inmobiliarias/:id/:im/:table" element={<Layout> <InmuebleDoc /> </Layout>} />
			<Route path="/inmobiliarias/:id/:im/estado_cuenta" element={<Layout> <InmuebleEdoCuenta /> </Layout>} />
			<Route path="/inmobiliarias/:id/:im/quejas_reportes" element={<Layout> <InmuebleQYR /> </Layout>} />
			<Route path="/inmobiliarias/:id/:im/facturas" element={<Layout> <InmuebleFacturas /> </Layout>} />
			<Route path="/quejasyreportes" element={<Layout> <QyR /> </Layout>} />
			<Route path="/gastos" element={<Layout> <Gastos /> </Layout>} />
			<Route path="/reportes" element={<Layout> <Estadisticas /> </Layout>} />
			<Route path="/mantenimiento" element={<Layout> <Mantenimiento /> </Layout>} />
			<Route path="/:idUser/:im" element={<Layout> <InmuebleUser /> </Layout>} />
			<Route path="/:idUser/:im/archivos_renta" element={<Layout> <InmuebleRenta /> </Layout>} />
			<Route path="/:idUser/:im/facturas" element={<Layout> <InmuebleFacturas /> </Layout>} />
			<Route path="/:idUser/:im/quejas_reportes" element={<Layout> <InmuebleQYR /> </Layout>} />
			<Route path="/:idUser/:im/estado_cuenta" element={<Layout> <InmuebleEdoCuenta /> </Layout>} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}

export default AppRouter;
